import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@carbon/react';
import { AtomizedForm } from 'atoms/form-atoms';
import { DrillingAssumptions } from './forms/drilling-assumptions';
import { CashflowAssumptions } from './forms/cashflow-assumptions';
import { DiscountRateAssumptions } from './forms/discount-rate-assumptions';
import { ScenariosForm } from './types';

import style from './scenario-builder.module.scss';

const GlobalScenarioForm = ({
  evaluationParameters,
}: {
  evaluationParameters: AtomizedForm<ScenariosForm['globalAssumptions']>;
}) => {
  return (
    <div className={style.tabsContained}>
      <Tabs>
        <TabList contained>
          <Tab>Drilling Assumptions</Tab>
          <Tab>Cashflow Assumptions</Tab>
          <Tab>Discount Rates Assumptions</Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <DrillingAssumptions
              form={evaluationParameters.drillingAssumptionAttributes}
            />
          </TabPanel>
          <TabPanel>
            <CashflowAssumptions
              form={evaluationParameters.cashflowAssumptionAttributes}
            />
          </TabPanel>
          <TabPanel>
            <DiscountRateAssumptions
              form={evaluationParameters.cashflowAssumptionAttributes}
            />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </div>
  );
};

export { GlobalScenarioForm };
